module.exports = __webpack_public_path__ + "img/hook_KONDOTEC_2.1be1bc5f.png";